import React, { useContext } from "react";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { Alert, CircularProgress } from "@mui/material";
import { useAgreementSailor } from "./hooks/useAgreementSailor";

const AgreementSailorContext = React.createContext();

export function useAgreementSailorContext() {
  return useContext(AgreementSailorContext);
}
export function AgreementSailorProvider({ applicationId, sailorId, children }) {
  const { setError } = useErrorMessage();
  const {
    agreementSailor: sailor,
    loading,
    error,
    notFound,
  } = useAgreementSailor({ applicationId, sailorId });

  if (error) {
    setError(error);
  }

  if (notFound) {
    return (
      <Alert severity="warning">
        No Sailor record snapshot was taken for this Agreement.
      </Alert>
    );
  }

  if (loading || !sailor) {
    return <CircularProgress sx={{ alignSelf: "center" }} />;
  }
  return (
    <AgreementSailorContext.Provider value={sailor}>
      {children}
    </AgreementSailorContext.Provider>
  );
}
